'use client';

import { SecurityPassword as Section } from '../../components/UserProfile/SecuritySections';
import { createSection } from '../createSection';

export const UserProfilePasswordSection = createSection('UserProfilePasswordSection', Section);
